// @ts-nocheck
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Input,
  VStack,
  useToast,
  FormControl,
  FormLabel,
  Text,
  FormErrorMessage,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { apiUrl, handleAxiosError, Service } from "@hex-labs/core";
import { Select } from "chakra-react-select";

import { HEXATHON_ID } from "../../../App";

interface Props {
  userId?: string | null;
  isOpen: boolean;
  onClose: () => void;
  swagItems: any;
}

const ItemCheckoutModal: React.FC<Props> = props => {
  const toast = useToast();
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    reset,
    control,
  } = useForm<any>({ defaultValues: { quantity: 1 } });

  const [user, setUser] = useState<any>(null);
  const [loadingUser, setLoadingUser] = useState(false);

  useEffect(() => {
    const getUserDetailInfo = async () => {
      if (!props.isOpen || !props.userId) {
        return;
      }

      setLoadingUser(true);
      try {
        const response = await axios.request({
          method: "GET",
          url: apiUrl(Service.HEXATHONS, `/hexathon-users/${HEXATHON_ID}/users/${props.userId}`),
          params: {
            hexathon: HEXATHON_ID,
          },
        });
        setUser(response.data);
      } catch (error: any) {
        handleAxiosError(error);
      } finally {
        setLoadingUser(false);
      }
    };

    getUserDetailInfo();
    reset();
  }, [props.userId, props.isOpen]);

  const handleFormSubmit = async (values: any) => {
    try {
      await axios.post(
        apiUrl(
          Service.HEXATHONS,
          `/hexathon-users/${HEXATHON_ID}/users/${props.userId}/actions/purchase-swag-item`
        ),
        {
          swagItemId: values.swagItem.value,
          quantity: values.quantity,
        }
      );
      toast({
        title: "Success!",
        description: "Item purchased",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      props.onClose();
    } catch (e: any) {
      handleAxiosError(e);
    }
  };

  return (
    <Modal
      onClose={props.onClose}
      isOpen={props.isOpen}
      isCentered
      motionPreset="none"
      blockScrollOnMount={false}
      useInert={false}
      onCloseComplete={() => {
        document.body.style.pointerEvents = "";
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Swag Item Checkout</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loadingUser ? (
            <Spinner />
          ) : (
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <VStack spacing={4} alignItems="normal">
                <Text>User: {user?.name}</Text>
                <Text>Points: {user?.points?.currentTotal}</Text>
                <Controller
                  control={control}
                  name="swagItem"
                  rules={{ required: "Please select a swag item" }}
                  render={({
                    field: { value, ref, ...field },
                    fieldState: { error: fieldError },
                  }) => (
                    <FormControl isInvalid={!!fieldError} isRequired>
                      <FormLabel>Swag Item</FormLabel>
                      <Select
                        {...field}
                        ref={ref}
                        value={value}
                        options={props.swagItems.map((swagItem: any) => ({
                          label: `${swagItem.name} [${swagItem.points} points]`,
                          value: swagItem.id,
                        }))}
                      />
                      <FormErrorMessage>{fieldError && fieldError.message}</FormErrorMessage>
                    </FormControl>
                  )}
                />
                <FormControl isRequired>
                  <FormLabel>Quantity</FormLabel>
                  <Input {...register("quantity")} type="number" inputMode="numeric" pattern="[0-9]*" min={1} />
                </FormControl>
                <Button colorScheme="purple" isLoading={isSubmitting} type="submit">
                  Checkout
                </Button>
              </VStack>
            </form>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default ItemCheckoutModal;
